<div class="At-EditProfile">
  <div class="At-EditProfileContent">
    <h3>edit profile</h3>
    <form class="At-EditProfileForm">
      <fieldset>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-3">
            <div class="At-ProfileImageBox">
              <label for="UploadImage">
                <img src="assets/images/profile/demo-img.png" alt="Edit Image">
                <input type="file" id="UploadImage">
              </label>
              <div class="At-badgePurple">
                <i class="icon-bage"></i>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-9">
            <div class="form-group mt-5">
              <label>username</label>
              <input type="text" class="form-control">
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Nickname</label>
              <div class="At-InputWithButton">
                <input type="text" class="form-control">
                <button type="button">change color</button>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Add Phone Number</label>
              <input type="text" class="form-control">
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Bio (What makes you unique?)</label>
              <input type="text" class="form-control">
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Add Your Location</label>
              <input type="text" class="form-control">
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="At-VipUserBox">
              <h4>Below Features are only available to VIP users</h4>
              <a href="javascript:void(0);">BECOME A VIP USER</a>
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Post Company Name</label>
              <input type="text" class="form-control">
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group">
              <label>Add Job Title</label>
              <input type="text" class="form-control">
            </div>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12">
            <div class="form-group mb-0">
              <label class="mb-25">Choose Any 3 to display (Set order to your liking)</label>
              <div class="At-CheckboxWithInput">
                <label class="At-checkBoxLabel">
                  <input type="checkbox" checked>
                  <span class="checkmark"></span>
                </label>
                <div class="At-InputWithButton">
                  <input type="text" class="form-control" placeholder="anita">
                  <button type="button"><i class="icon-color-picker"></i></button>
                </div>
                <button type="button"><i class="icon-menu-1"></i></button>
              </div>
              <div class="At-CheckboxWithInput">
                <label class="At-checkBoxLabel">
                  <input type="checkbox">
                  <span class="checkmark"></span>
                </label>
                <div class="At-InputWithButton">
                  <input type="text" class="form-control" placeholder="Last Name">
                  <button type="button"><i class="icon-color-picker"></i></button>
                </div>
                <button type="button"><i class="icon-menu-1"></i></button>
              </div>
              <div class="At-CheckboxWithInput">
                <label class="At-checkBoxLabel">
                  <input type="checkbox" checked>
                  <span class="checkmark"></span>
                </label>
                <div class="At-InputWithButton">
                  <input type="text" class="form-control" placeholder="Enzzy">
                  <button type="button"><i class="icon-color-picker"></i></button>
                </div>
                <button type="button"><i class="icon-menu-1"></i></button>
              </div>
              <div class="At-CheckboxWithInput">
                <label class="At-checkBoxLabel">
                  <input type="checkbox" checked>
                  <span class="checkmark"></span>
                </label>
                <div class="At-InputWithButton">
                  <input type="text" class="form-control" placeholder="Software Enginner">
                  <button type="button"><i class="icon-color-picker"></i></button>
                </div>
                <button type="button"><i class="icon-menu-1"></i></button>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </form>
  </div>
</div>
